import { Box, Card, Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExtendedAccident } from '../../../../../backendsdk';
import useProfile from '../../../../../hooks/profile';
import { OE_ROLES } from '../../../Users/UsersComponent';
import AccidentDamagePayment from '../../AccidentDamagePayment';
import { ClaimsTable } from '../../ClaimsModal';

interface PaymentsTabProps {
    details: ExtendedAccident;
    onSave: CallableFunction;
    setSending: CallableFunction;
    handlingStatusList: Array<string>;
    setHandlingStatusList: CallableFunction;
    setAlert: CallableFunction;
    updateCallbacks: Record<string, CallableFunction>;
    setUpdateCallbacks: CallableFunction;
    validateCallbacks: Record<string, CallableFunction>;
    setValidateCallbacks: CallableFunction;
    removeCallbacks: CallableFunction;
    handleSave: CallableFunction;
    sending: boolean;
}

const PaymentsTab: React.FC<PaymentsTabProps> = (props: PaymentsTabProps) => {
    const { t } = useTranslation();
    const { profile } = useProfile();
    const { details } = props;
    const showClaims = OE_ROLES.includes(profile.role);

    const conditionalTooltip = (component: React.ReactNode) => {
        if (details.accident_id === 0) {
            return (
                <Tooltip title={t('content.accidents.form.please_save')} followCursor>
                    <Box>{component}</Box>
                </Tooltip>
            );
        } else {
            return component;
        }
    };

    return (
        <Box sx={{ p: 1 }}>
            <Grid container spacing={1} columns={2}>
                <Grid item xs={2} sm={1}>
                    <Card sx={{ height: '100%' }}>
                        {conditionalTooltip(
                            <AccidentDamagePayment
                                details={details}
                                onSave={props.handleSave}
                                setAlert={props.setAlert}
                                disabled={props.sending}
                            />,
                        )}
                    </Card>
                </Grid>
                {showClaims && props.details.claims.length > 0 ? (
                    <Grid item xs={2} sm={1}>
                        <Card sx={{ p: 1 }}>
                            <Typography variant="overline">{t('content.accidents.damage.claims')}</Typography>
                            <ClaimsTable claims={props.details.claims} />
                        </Card>
                    </Grid>
                ) : null}
            </Grid>
        </Box>
    );
};

export default PaymentsTab;
